import { compose } from 'redux';
import { connect } from 'react-redux';
import { simoSubPage } from 'decorators/subPage';
import { getSubmitStatus, getAllSimoPlans, getLoggedInUser } from 'reducers';
import { updatePlan } from 'actions/simoSubs';
import { fetchAllPlans } from 'actions/simoPlans';
import injectPreactivation from 'decorators/injectPreactivation';
import SimoSubNav from 'components/SubNav/simo';
import UpdatePlan from './UpdatePlan';
import PlanForm from 'components/PlanForm';

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'plan'),
  plans: getAllSimoPlans(state),
  SubNav: SimoSubNav,
  heading: 'Update Simo Plan',
  upgradePlanLink: (subId) => `/simo/subscriptions/${subId}/upgrade-invoice`,
  isSimo: true,
  PlanForm,
  showLockCheckbox: false,
  loggedInUser: getLoggedInUser(state),
});

const mapDispatchToProps = {
  updatePlan,
  fetchAllPlans,
};

export default compose(
  simoSubPage,
  injectPreactivation,
  connect(mapStateToProps, mapDispatchToProps),
)(UpdatePlan);
